import React from "react";
import "../App.css";
import {
  FaInstagram,
  FaFacebook,
  FaSoundcloud,
  FaTwitter,
} from "react-icons/fa";
import Aili5 from "../images/aili1.jpg";
function Aili() {
  return (
    <div>
      <div className="flex__layout">
        <div className="artist__description" data-aos="fade-down">
          <h1>Aili</h1>
          <br />
          <h3>Songwriter / Artist / Topliner.</h3>
          <br />
          <p>
            Aili grew up in one of the the coldest places in northern parts of
            Norway, Karasjok.
          </p>
          <br />
          <p>
            Karasjok is a Sami culture town where the inhabitants speak the
            Northern Sami language, a language spoken by only 25 700 people in
            the world.
          </p>
          <br />
          <p>
            With a musical education at the infamous music School “Limpi” in
            Norway, Aili has proven herself not only as a good performing and
            recording artist, but also as a very talented songwriter. This
            resulting in numerous successful releases with labels such as
            Universal Music, Loudkult and Soave.
          </p>
          <br />
          <p>
            It’s safe to say that Aili has a very bright future ahead of her.
          </p>
          <br />
          <div className="social__media__icons">
            <li>
              <a
                href="https://www.instagram.com/ailiofficial/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <FaInstagram fill="white" size={40} />
                </p>
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/AiliOfficial"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <FaFacebook fill="white" size={40} />
                </p>
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/aili_official"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <FaTwitter fill="white" size={40} />
                </p>
              </a>
            </li>
            <li>
              <a
                href="https://soundcloud.com/ailiofficial"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <FaSoundcloud fill="white" size={40} />
                </p>
              </a>
            </li>
          </div>
        </div>

        {/*Photos or Videos + playlist.*/}
        <div>
          <div className="__photos" data-aos="fade-up">
            <img src={Aili5} className="artists__photo__size" />
          </div>
        </div>
      </div>

      <div className="spotify__playlist" data-aos="fade-right">
        <iframe
          src="https://open.spotify.com/embed/playlist/4xPNr62peVZG5Cd7tQ8ZjH?utm_source=generator&theme=0"
          width="800"
          height="380"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        ></iframe>
      </div>
    </div>
  );
}

export default Aili;
